import { useState } from 'react';

import { Modal } from 'antd';
import { Check, ChevronLeft, ChevronRight } from 'lucide-react';

import { assetUrl } from '../api';
import { templatePreviewPages } from '../helpers';

import styles from '../index.module.scss';

function PreviewBody({ template, selected, onUse }) {
    const pages = templatePreviewPages(template);
    const [index, setIndex] = useState(0);
    const page = pages[index] || pages[0];
    const go = (delta) => setIndex((current) => (current + delta + pages.length) % pages.length);

    return (
        <div
            className={styles.previewBody}
            onKeyDown={(event) => {
                if (event.key === 'ArrowLeft') go(-1);
                if (event.key === 'ArrowRight') go(1);
            }}
        >
            <div className={styles.previewHeader}>
                <div>
                    <h3>{template.name}</h3>
                    {template.description ? <p>{template.description}</p> : null}
                </div>
                <div className={styles.previewTags}>
                    {template.categoryName ? <span>{template.categoryName}</span> : null}
                    <span>{pages.length} 页示例</span>
                </div>
            </div>

            <div className={styles.previewStage}>
                {pages.length > 1 ? (
                    <button
                        type="button"
                        className={styles.previewNav}
                        aria-label="上一页"
                        onClick={() => go(-1)}
                    >
                        <ChevronLeft size={20} aria-hidden />
                    </button>
                ) : null}
                <figure>
                    <img
                        src={assetUrl(page.imageUrl)}
                        alt={`${template.name} 第 ${page.pageNumber} 页：${page.title}`}
                        width={960}
                        height={540}
                    />
                    <figcaption>
                        第 {page.pageNumber} 页 · {page.title}
                    </figcaption>
                </figure>
                {pages.length > 1 ? (
                    <button
                        type="button"
                        className={styles.previewNav}
                        aria-label="下一页"
                        onClick={() => go(1)}
                    >
                        <ChevronRight size={20} aria-hidden />
                    </button>
                ) : null}
            </div>

            {pages.length > 1 ? (
                <ol className={styles.previewStrip} aria-label="示例页">
                    {pages.map((item, itemIndex) => (
                        <li key={`${item.pageNumber}-${itemIndex}`}>
                            <button
                                type="button"
                                aria-label={`第 ${item.pageNumber} 页：${item.title}`}
                                aria-current={itemIndex === index ? 'true' : undefined}
                                onClick={() => setIndex(itemIndex)}
                            >
                                <img
                                    src={assetUrl(item.imageUrl)}
                                    alt=""
                                    width={160}
                                    height={90}
                                    loading="lazy"
                                    decoding="async"
                                />
                            </button>
                        </li>
                    ))}
                </ol>
            ) : null}

            <div className={styles.modalActions}>
                <p className={styles.footNote}>
                    示例页展示版式与配色，生成时会换成你的内容，页数由内容决定。
                </p>
                <button
                    type="button"
                    className={styles.primaryButton}
                    onClick={() => onUse(template)}
                >
                    <Check size={16} aria-hidden />
                    {selected ? '已选择，继续' : '使用此模板'}
                </button>
            </div>
        </div>
    );
}

export default function TemplatePreviewModal({ template, selected, onClose, onUse }) {
    return (
        <Modal
            open={Boolean(template)}
            onCancel={onClose}
            footer={null}
            width={1000}
            centered
            destroyOnClose
            title={null}
            className={styles.previewModal}
        >
            {template ? (
                <PreviewBody
                    key={template.id}
                    template={template}
                    selected={selected}
                    onUse={onUse}
                />
            ) : null}
        </Modal>
    );
}
